import { selectAllEntities, selectEntities, selectEntity } from '@hozana/api/selectors'

import type { TState } from 'config/types'

import type { TTag } from './types'

export const selectTag = (state: TState, tagId: number): TTag => selectEntity(state, 'tag', tagId)
export const selectTags = (state: TState, tagsArray: number[]): TTag[] => selectEntities(state, 'tag', tagsArray)

export const selectAllTags = (state: TState): TTag[] => selectAllEntities(state, 'tag')

export const selectTagBySlug = (state: TState, tagSlug: string): TTag | null =>
  tagSlug && selectAllTags(state)?.find((tag) => tag.slug === tagSlug)
